const STORAGE_LOCALE_KEY = 'HotelPortalLocale';
const STORAGE_V3_BANNER_DISMISS_KEY = 'HotelPortalV3BannerDismissed';

export default { STORAGE_LOCALE_KEY, STORAGE_V3_BANNER_DISMISS_KEY };
